export default __webpack_public_path__ + "static/media/01_zaludy_d-min.f3de8acd.jpg";